// import MoneyFormatter from '../utils/format-money';

class CardProductSmall extends HTMLElement {
  constructor() {
    super();
    this.cardProductElement = this;
    this.formElement = this.cardProductElement.querySelector('form');
    this.sectionId = this.cardProductElement.getAttribute('data-section-id');
    this.productPriceElement = this.cardProductElement.querySelector('[data-product-price]');
    this.mediaElement = this.cardProductElement.querySelector('.variant-image');
    this.hoverMediaElement = this.cardProductElement.querySelector('.hover-image');
    this.allInputElement = this.formElement.querySelectorAll('input');
    this.allLabelElements = this.formElement.querySelectorAll('label');

    this.addEventListener('change', this.handleVariantChange, true, { passive: false });

    this.allLabelElements.forEach(
      (labelElement) => {
        labelElement.addEventListener('mouseenter', (event) => {
          const target = event.target;
          const input = this.cardProductElement.querySelector('input[id="' + target.getAttribute('for') + '"]');
          input.checked = true;

          this.handleVariantChange();
        });
      },
      true,
      { passive: false }
    );
  }

  handleUpdateColor = (event) => {
    // get the active color from the event details.
    const activeColor = event.detail.activeColor;
    const newActiveInput = Array.from(this.allInputElement).find((input) => input.value === activeColor);

    newActiveInput.checked = true;
    this.handleVariantChange();
  };

  handleVariantChange = () => {
    const previousActiveVariantId = this.formElement.getAttribute('data-current-variant-id');
    this.cardProductElement.setAttribute('aria-busy', 'true');

    this.updateOptions();
    this.getSelectedVariant();

    if (previousActiveVariantId && previousActiveVariantId == this.currentVariant.id) {
      this.cardProductElement.setAttribute('aria-busy', 'false');
    } else {
      this.updateProductButton();

      this.previousActiveVariant = this.currentVariant;
    }
  };

  updateOptions = () => {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));

    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input'))?.find((radio) => radio.checked)?.value;
    });
  };

  getSelectedVariant = () => {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  };

  getVariantData = () => {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);

    return this.variantData;
  };

  updateProductButton = () => {
    // Replace the product media.
    if (this.currentVariant.featured_image) {
      this.mediaElement.setAttribute('src', this.currentVariant.featured_image);
      this.mediaElement.setAttribute('srcset', this.currentVariant.featured_image);

      if (this.currentVariant.hover_image && !this.currentVariant.hover_image.includes('Liquid error')) {
        this.hoverMediaElement?.setAttribute('src', this.currentVariant.hover_image);
        this.hoverMediaElement?.setAttribute('srcset', this.currentVariant.hover_image);
      } else {
        this.hoverMediaElement?.setAttribute('src', this.currentVariant.featured_image);
        this.hoverMediaElement?.setAttribute('srcset', this.currentVariant.featured_image);
      }

      const targetImage = new Image(800, 400);
      targetImage.src = this.currentVariant.featured_image;

      targetImage.onload = () => {
        this.cardProductElement.setAttribute('aria-busy', 'false');
      };
    } else {
      this.cardProductElement.setAttribute('aria-busy', 'false');
    }

    if (this.productPriceElement) {
      if (this.currentVariant.compare_at_price) {
        this.productPriceElement.innerHTML = `
        <div class="flex gap-1x h-fit mt-auto">
          <p class="text-heading-3xs line-through">

          </p>
          <p class="text-heading-3xs">

          </p>
        </div>`;
      } else {
        this.productPriceElement.innerHTML = `
        <div class="flex gap-1x h-fit mt-auto">
          <p class="text-heading-3xs">

          </p>
        </div>`;
      }
    }

    this.formElement.setAttribute('data-current-variant-id', this.currentVariant.id);
  };
}

// Check if element is defined, if not define it..
// eslint-disable-next-line no-undefined
if (customElements.get('card-product-small') === undefined) {
  customElements.define('card-product-small', CardProductSmall);
}
